import React from "react";
import styled from "styled-components";
import { FiCreditCard, FiDollarSign } from "react-icons/fi";

const PaymentMethodContainer = styled.div`
  margin-bottom: 2rem;
`;

const PaymentMethodTitle = styled.h3`
  color: #2d5016;
  margin-bottom: 1rem;
  font-size: 1.2rem;
  font-weight: 600;
`;

const PaymentMethods = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  margin-bottom: 1rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const PaymentMethodCard = styled.div`
  border: 2px solid ${(props) => (props.$selected ? "#2d5016" : "#e0e0e0")};
  border-radius: 12px;
  padding: 1.5rem;
  cursor: pointer;
  transition: all 0.3s ease;
  background: ${(props) => (props.$selected ? "#f8f9fa" : "#fff")};
  position: relative;

  &:hover {
    border-color: #2d5016;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(45, 80, 22, 0.1);
  }
`;

const PaymentMethodHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
`;

const PaymentIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: ${(props) => (props.$selected ? "#2d5016" : "#f0f0f0")};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => (props.$selected ? "#fff" : "#666")};
  font-size: 1.2rem;
`;

const PaymentMethodName = styled.h4`
  margin: 0;
  color: #2d5016;
  font-size: 1.1rem;
  font-weight: 600;
`;

const PaymentMethodDescription = styled.p`
  margin: 0;
  color: #666;
  font-size: 0.9rem;
  line-height: 1.4;
`;

const SelectedIndicator = styled.div`
  position: absolute;
  top: 12px;
  right: 12px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #2d5016;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 12px;
  font-weight: bold;
`;

const CashPaymentNote = styled.div`
  background: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 8px;
  padding: 1rem;
  margin-top: 1rem;
  color: #856404;
  font-size: 0.9rem;
  line-height: 1.4;
`;

const MMGPaymentNote = styled.div`
  background: #d1ecf1;
  border: 1px solid #bee5eb;
  border-radius: 8px;
  padding: 1rem;
  margin-top: 1rem;
  color: #0c5460;
  font-size: 0.9rem;
  line-height: 1.4;
`;

const PaymentMethodSelector = ({
  selectedMethod,
  onMethodChange,
  fulfillmentMethod,
  mealPlan,
}) => {
  const paymentMethods = [
    {
      id: "mmg",
      name: "MMG Payment",
      icon: FiCreditCard,
      description: "Pay securely with your MMG account",
      note: "Payment will be processed through MMG and sent to NourishGY, then distributed to the vendor.",
    },
    {
      id: "cash",
      name: "Cash Payment",
      icon: FiDollarSign,
      description: `Pay with cash upon ${fulfillmentMethod === "delivery" ? "delivery" : "pickup"}`,
      note: `You will pay the vendor directly when your meal is ${fulfillmentMethod === "delivery" ? "delivered" : "picked up"}.`,
    },
  ];

  return (
    <PaymentMethodContainer>
      <PaymentMethodTitle>Choose Payment Method</PaymentMethodTitle>

      <PaymentMethods>
        {paymentMethods.map((method) => (
          <PaymentMethodCard
            key={method.id}
            $selected={selectedMethod === method.id}
            onClick={() => onMethodChange(method.id)}
          >
            {selectedMethod === method.id && (
              <SelectedIndicator>✓</SelectedIndicator>
            )}

            <PaymentMethodHeader>
              <PaymentIcon $selected={selectedMethod === method.id}>
                <method.icon />
              </PaymentIcon>
              <PaymentMethodName>{method.name}</PaymentMethodName>
            </PaymentMethodHeader>

            <PaymentMethodDescription>
              {method.description}
            </PaymentMethodDescription>
          </PaymentMethodCard>
        ))}
      </PaymentMethods>

      {selectedMethod === "cash" && (
        <CashPaymentNote>
          <strong>Cash Payment:</strong>{" "}
          {paymentMethods.find((m) => m.id === "cash")?.note}
        </CashPaymentNote>
      )}

      {selectedMethod === "mmg" && (
        <MMGPaymentNote>
          <strong>MMG Payment:</strong>{" "}
          {paymentMethods.find((m) => m.id === "mmg")?.note}
        </MMGPaymentNote>
      )}
    </PaymentMethodContainer>
  );
};

export default PaymentMethodSelector;
